<template>
  <v-layout
    row
    wrap
    fluid
  >
    <v-flex>
      <v-card class="add-card max-shadow">
        <v-card-title>
          <div class="headline">
            New Vendor
          </div>
          <v-spacer />
          <v-btn
            color="primary"
            flat
            @click="addVendor"
          >
            Add
          </v-btn>
        </v-card-title>
        <v-form ref="form">
          <v-container
            grid-list-lg
            class="pa-3"
            fluid
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="vendorName"
                  v-model="vendorName"
                  :rules="[v => !!v || 'Vendor Name is required']"
                  autofocus
                  name="vendor-name"
                  label="Vendor Name"
                  hint="Restaurant Name"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="adminName"
                  v-model="admin.name"
                  :rules="[v => !!v || 'Admin Name is required']"
                  name="admin-name"
                  label="Admin Name"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
              >
                <v-text-field
                  ref="adminEmail"
                  v-model="admin.email"
                  :rules="validationRules.email"
                  name="admin-email"
                  label="Admin Email"
                  type="email"
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                d-flex
                align-center
              >
                <v-text-field
                  ref="adminPhone"
                  v-model="admin.phone"
                  :rules="validationRules.phone"
                  prefix="+91"
                  mask="##########"
                  name="admin-phone"
                  label="Admin Phone"
                  clear-icon="cancel"
                  clearable
                  required
                />
              </v-flex>
              <v-flex
                xs12
                sm6
                d-flex
                align-center
              >
                <v-textarea
                  v-model="address"
                  outline
                  label="Address"
                  name="address"
                  hint="Helps to locate vendor in Max towers. ex. #36, Ground floor"
                  :rules="[v => !!v || 'Address is required']"
                  required
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment';

import validationRules from '@/mixins/validation-rules';
import { firestore } from '@/firebase';
import { generateUID } from '@/utils';

export default {
  name: 'NewVendor',
  mixins: [validationRules],
  data() {
    return {
      vendorName: null,
      admin: {
        name: null,
        email: null,
        phone: null
      },
      address: null
    };
  },
  computed: {
    adminFormatted() {
      return {
        name: this.admin.name,
        email: this.admin.email,
        phone: `+91${this.admin.phone}`
      };
    }
  },
  methods: {
    addVendor() {
      if (!this.$refs.form.validate()) return;

      firestore
        .collection('vendors')
        .doc(generateUID())
        .set({
          vendorName: this.vendorName,
          admin: this.adminFormatted,
          facility: 'fnb',
          address: this.address,
          joinDate: moment().toDate()
        });

      this.$router.push('/max-admin/fnb/vendors');
    }
  }
};
</script>

<style scoped></style>
